import { render } from "./EditAdmin.vue?vue&type=template&id=a475f8d4&scoped=true"
import script from "./EditAdmin.vue?vue&type=script&lang=js"
export * from "./EditAdmin.vue?vue&type=script&lang=js"

import "./EditAdmin.vue?vue&type=style&index=0&id=a475f8d4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a475f8d4"]])

export default __exports__